import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Avatar, SxProps, Theme, Typography } from '@mui/material'

import { imgSt, titleWrapper, wrapper, wrapperMobile } from './bottom-card-title.styled'
import { useNavigateWithParams } from 'src/hooks/common/use-navigate-with-params.hook'
import { DEFAULT_LANGUAGE, ROUTES } from 'src/constants'

interface IProps {
  title: string
  image: string
  twitterTitle: string
  hideAccountName?: boolean
  accountId: string
  avatarSx?: SxProps<Theme>
}

export const BottomCardTitle = ({ title, image, hideAccountName, accountId, avatarSx }: IProps) => {
  const [, i18n] = useTranslation()
  const location = useLocation()
  const isMobile = innerWidth < 770
  const customNav = useNavigateWithParams()
  const handleNavigate = (to: string) => () => customNav(to)

  return (
    <div
      id="index__components-bottom-card-title__div__l25"
      className={isMobile ? wrapperMobile : wrapper}
    >
      <Link
        to={
          i18n.language === DEFAULT_LANGUAGE
            ? `/${ROUTES.ACCOUNT}/${accountId}`
            : `/${i18n.language}/${ROUTES.ACCOUNT}/${accountId}`
        }
        state={{ from: location.pathname }}
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        <div
          id="index__components-bottom-card-title__div__l35"
          className={titleWrapper}
          onClick={handleNavigate(ROUTES.ACCOUNT)}
        >
          <Avatar
            id="index__components-bottom-card-title__avatar__l36"
            className={imgSt}
            alt={title}
            src={image}
            sx={avatarSx}
          />
          {!hideAccountName && (
            <Typography id="index__components-bottom-card-title__typography__l37" variant="h5">
              {title}
            </Typography>
          )}
        </div>
      </Link>
      {/* <span className={titleDivider}/>
         <ShareButton />
         <TwitterShare title={twitterTitle} /> */}
    </div>
  )
}
